import { render, staticRenderFns } from "./CompanyIndex.vue?vue&type=template&id=17ae2710"
import script from "./CompanyIndex.vue?vue&type=script&lang=js"
export * from "./CompanyIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports